
export default {
  list: [
    {
      title: 'یک ساعت',
      value: 60
    },
    {
      title: 'یک ساعت و 15 دقیقه',
      value: 75
    },
    {
      title: 'یک ساعت و 30 دقیقه',
      value: 90
    },
    {
      title: 'یک ساعت و 45 دقیقه',
      value: 105
    },
    {
      title: 'دو ساعت',
      value: 120
    }
  ],
  values: {
    oneHour: 60,
    anHourAndaQuarter: 75,
    anHourAndaHalf: 90,
    oneHourAndFortyFiveMinutes: 105,
    twoHours: 120
  }
};